<template>
  <div>
    <div class="page-background">
      <div>
        <div>
          <p class="briefIntroduction">
          </p>
        </div>
      </div>
    </div>
    <div class="MyDiv">
      <div class="MyDivLeft">
        <div class="MyLogoAndName">
          <div class="MyLogo">
            <img src="../assets/ball_sort_logo.jpg" class="MyLogoImg">
          </div>
          <div class="MyAppName">
            <p class="MyAppNameP">BallSort</p>
            <p class="MyAppNameP1">BallSort</p>
          </div>
        </div>
        <div class="MyIntroduce">
          <p class="MyIntroducep">"Ball Sort" is a simple yet addictive puzzle game that tests your logical thinking and observation skills!</p>
        </div>
      </div>
      <div class="MyDivRight">
        <img src="../assets/ball_sort_info.jpg" class="MyDivRightImg">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeView',
  data () {
    return {
      // images: [
      //   './assets/store1.jpg',
      //   './assets/store2.jpg',
      //   './assets/store3.jpg',
      //   './assets/store4.jpg',
      //   './assets/store5.jpg'
      // ]
      // images: [
      //   {
      //     id: 1,
      //     imgSrc: require('../assets/store1.jpg'),
      //     descInfo: '【漫影相机】个性化你的照片。【漫艺术效果】丰富多彩的卡通、素描、艺术风格效果任你选！【挡脸特效】贴心保护隐私又有无限趣味<br>玩法。【百变发型】各种炫酷时尚的发型，在线实时体验。【趣味贴纸】萌趣表情 & 鬼马自拍的小秘诀。【多彩滤镜】百变风格质感滤<br>镜，可盐可甜。【炫彩效果】一键get，BlingBling炫彩特效加持仙气值。',
      //     appName: '漫影相机'
      //   },
      //   {
      //     id: 2,
      //     imgSrc: require('../assets/store2.jpg'),
      //     descInfo: '【漫影相机】个性化你的照片。【漫艺术效果】丰富多彩的卡通、素描、艺术风格效果任你选！【挡脸特效】贴心保护隐私又有无限趣味<br>玩法。【百变发型】各种炫酷时尚的发型，在线实时体验。【趣味贴纸】萌趣表情 & 鬼马自拍的小秘诀。【多彩滤镜】百变风格质感滤<br>镜，可盐可甜。【炫彩效果】一键get，BlingBling炫彩特效加持仙气值。',
      //     appName: '便签'
      //   },
      //   {
      //     id: 3,
      //     imgSrc: require('../assets/store3.jpg'),
      //     descInfo: '【漫影相机】个性化你的照片。【漫艺术效果】丰富多彩的卡通、素描、艺术风格效果任你选！【挡脸特效】贴心保护隐私又有无限趣味<br>玩法。【百变发型】各种炫酷时尚的发型，在线实时体验。【趣味贴纸】萌趣表情 & 鬼马自拍的小秘诀。【多彩滤镜】百变风格质感滤<br>镜，可盐可甜。【炫彩效果】一键get，BlingBling炫彩特效加持仙气值。',
      //     appName: 'EP相册'
      //   }
      // ]
    }
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.page-background {
  background-image: url('../assets/0000.jpg'); /* 替换为你的图片路径 */
  background-size: cover; /* 背景图片覆盖整个元素 */
  background-position: center; /* 背景图片居中 */
  background-repeat: no-repeat; /* 不重复背景图片 */
  height: 60vh; /* 可以根据需要设置高度 */
  width: 100%; /* 可以根据需要设置宽度 */
  margin-top: -25px;
  overflow-x: auto; /* 水平滚动条 */
  //white-space: nowrap; /* 防止内容换行 */
}
.companyName{
  position: absolute;
  //top: 3%; /* 根据需要调整 */
  //left: 11%;
  //transform: translate(-50%, -50%); /*水平垂直居中*/
  top: 10px;
  left: 10px;
  color: white; /* 根据背景调整文字颜色 */
  font-size: 25px;
}
.briefIntroduction{
  position: absolute;
  top: 25%; /* 根据需要调整 */
  left: 50%;
  transform: translate(-50%, -50%);
  color: white; /* 根据背景调整文字颜色 */
  font-size: 80px;
  //margin-top: 500px;
  //text-align: center;
}
.briefIntroduction2{
  position: absolute;
  top: 83%; /* 根据需要调整 */
  left: 50%;
  transform: translate(-50%, -50%);
  color: white; /* 根据背景调整文字颜色 */
}
.briefIntroduction3{
  //width: 100%;
  //margin-top: 800px;
  //height: 200px;
  //background-color: white;
  //position: absolute;
  //top: 110%; /* 根据需要调整 */
  //left: 50%;
  //transform: translate(-50%, -50%);
  //margin-top: 400px;
  text-align: center;
  //margin-top: 1800px;
}
//.briefIntroduction4{
//  margin-top: 800px;
//  position: absolute;
//  //top: 20%; /* 根据需要调整 */
//  left:50%;
//  //transform: translate(-50%, -50%);
//  font-weight: bold;
//}
.briefIntroduction5{
  //margin-top: 800px;
  position: absolute;
  //left: 25%;
  top: 110%; /* 根据需要调整 */
  //margin-top: 900px;
  padding: 20px;
  //left:50%;
  //transform: translate(-50%, -50%);
  //text-align: center;
  //width: 70%;
}
.juse{
  display: flex;
  justify-content: space-between;
}
.MyInfo{
  width: 25%;
  height: 500px;
  //background-color: red;
  position: absolute;
  top: 130%;
  left: 5%;
  box-shadow: 0 0 3px 0 #ccc;
  text-align: center;
}

.NoteInfo{
  width: 25%;
  height: 500px;
  //background-color: red;
  position: absolute;
  top: 130%;
  left: 37%;
  box-shadow: 0 0 3px 0 #ccc;
  text-align: center;
}
.EPInfo{
  width: 25%;
  height: 500px;
  //background-color: red;
  position: absolute;
  top: 130%;
  left: 69%;
  box-shadow: 0 0 3px 0 #ccc;
  text-align: center;
}
.logo{
  //position: absolute;
  //top: 160%; /* logo 相对于父容器顶部的偏移量 */
  //left: 50%; /* logo 相对于父容器左侧的偏移量 */
  //transform: translate(-50%, 20%); /* 将 logo 水平和垂直居中 */
  width: 100px; /* logo 图片的宽度 */
  height: 100px; /* logo 图片的高度 */
  display: inline-block;
}
.productInfo{
  //position: absolute;
  //top: 150%; /* logo 相对于父容器顶部的偏移量 */
  //left: 55%; /* logo 相对于父容器左侧的偏移量 */
  font-weight: bold;
  font-size: 25px;
}
.productInfo2{
  //position: absolute;
  //top: 165%; /* logo 相对于父容器顶部的偏移量 */
  //left: 36%; /* logo 相对于父容器左侧的偏移量 */
}
.image-container {
  display: flex; /* 使用 flex 布局 */
  position: absolute;
  //top:180%;
  justify-content: center; /* 将项目水平居中对齐 */
  top:230%;
  //left: 10%;
  //transform: translate(-50%, -50%);
}
.buttonDiv{
  width: 100%;
  height: 200px;
  background-color: black;
  display: flex;
  flex-direction: column;
  //position: absolute;
  //top: 270%; /* 根据需要调整 */
  //left: 50%;
  //transform: translate(-50%, -50%);
}
.companyName2{
  color: white;
  text-align: center;
  //position: absolute;
  //left: 50%;
  //transform: translate(-50%, -50%);
  font-size: 18px;
  margin-top: 40px;
}
.companyName3{
  //position: absolute;
  //top: 44%; /* 根据需要调整 */
  //left: 50%;
  //transform: translate(-50%, -50%);
  color: #6565c6;
  text-align: center;
}

//.el-carousel__item h3 {
//  color: #ffffff;
//  font-size: 14px;
//  opacity: 0.75;
//  line-height: 200px;
//  margin: 0;
//}
//
//.el-carousel__item:nth-child(2n) {
//  background-color: #ffffff;
//}
//
//.el-carousel__item:nth-child(2n+1) {
//  background-color: #ffffff;
//}
//.carousel-item-container {
//  display: flex; /* 使用flex布局 */
//  justify-content: space-between; /* 子元素之间的空间分布 */
//  //align-items: center; /* 子元素垂直居中 */
//  height: 100%; /* 继承外层容器的高度 */
//  padding: 20px; /* 可选：添加内边距 */
//}
//
//.carousel-item-description {
//  flex: 1; /* 占据可用空间的1份 */
//  //margin-right: 100px; /* 可选：右侧外边距 */
//}
//.leftBig{
//  display: flex; /* 使用flex布局 */
//  justify-content: space-between; /* 子元素之间的空间分布 */
//}
//.carousel-item-image img {
//  max-width: 50%; /* 限制图片最大宽度为容器的一半 */
//  height: auto; /* 图片高度自动，保持比例 */
//  margin-left: 180px;
//}
//.block{
//  width: 80%;
//  position: absolute;
//  top:150%; /* 根据需要调整 */
//  left: 50%;
//  transform: translate(-50%, -50%);
//}
//.carousel-item-container {
//  display: flex;
//  justify-content: space-between;
//  height: 100%;
//  padding: 20px;
//}
//
//.leftBig {
//  display: flex;
//  //flex-direction: column; /* 改为列方向布局 */
//  //align-items: flex-start; /* 子元素垂直对齐 */
//  //width: 100%; /* 确保宽度占满 */
//  justify-content: space-between; /* appName和图片之间留有空隙 */
//  //align-items: center; /* 垂直居中 */
//}
//
//.carousel-item-description {
//  display: flex;
//  flex-direction: column; /* 改为列方向布局 */
//  align-items: flex-start; /* 垂直对齐 */
//  width:200px;
//  margin-left: 50px;
//}
//
//.carousel-item-thumb {
//  width: 100px;
//  height: 100px;
//  margin-bottom: 10px; /* 图片下面留一点空间 */
//  margin-left: 25%;
//}
//
//.appName {
//  /* 这里可以添加appName的样式 */
//}
//
//.app-description {
//  /* 这里可以添加app介绍的样式 */
//  margin-top: 10px; /* 与上面的元素保持一点间距 */
//  width: 100px
//}
//
//.carousel-item-image img {
//  max-width: 80%;
//  height: 80%;
//  //margin-left: 40px; /* 让图片靠右对齐 */
//  margin-top: 10%;
//}
//.demonstration{
//  font-size: 30px;
//  font-weight: bold;
//  text-align: center;
//  margin-top: 18%;
//}
.MyDiv{
  width: 100%;
  height: 100vh;
  //background-color: red;
  display: flex;
}
.MyDivLeft{
  width: 50%;
  height: 100vh;
  //background-color: #6565c6;
  margin-left: 100px;
}
.MyDivRight{
  width: 50%;
  height: 100vh;
  //background-color: #545454;
}
.MyLogoAndName{
  height: 40%;
  width: 100%;
  //background-color: green;
  display: flex;
}
.MyIntroduce{
  height: 60%;
  width: 100%;
  //background-color: seashell;
}
.MyLogo{
  height: 100%;
  width: 30%;
  //background-color: red;
}
.MyAppName{
  height: 100%;
  width: 70%;
  //background-color: #6565c6;
}
.MyLogoImg{
  width: 65%;
  height: 50%;
  margin-top: 30%;
  margin-left: 30%;
}
.MyAppNameP{
  font-size: 60px;
  font-weight: bold;
  margin-left: 10%;
  margin-top: 15%;
}
.MyAppNameP1{
  font-size: 30px;
  margin-left: 10%;
  margin-top: -10%;
  color: #707987;
}
.MyIntroducep{
  font-size: 20px;
  width: 80%;
  margin-left: 10%;
}
.MyDivRightImg{
  width: 42%;
  height: 80%;
  margin-top: 10%;
  margin-left: 20%;
}
</style>
